import * as React from 'react';

function SvgFileEarmarkX(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M6.854 7.146a.5.5 0 10-.708.708L7.293 9l-1.147 1.146a.5.5 0 00.708.708L8 9.707l1.146 1.147a.5.5 0 00.708-.708L8.707 9l1.147-1.146a.5.5 0 00-.708-.708L8 8.293 6.854 7.146z' />
			<path d='M14 14V4.5L9.5 0H4a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2zM9.5 3A1.5 1.5 0 0011 4.5h2V14a1 1 0 01-1 1H4a1 1 0 01-1-1V2a1 1 0 011-1h5.5v2z' />
		</svg>
	);
}

export default SvgFileEarmarkX;
